'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
`;

export const content = css`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  @media screen and (width > ${theme.sizes.screens.md}) {
    flex-direction: row;
    grid-template-columns: 160px 1fr;
  }
`;

export const stores = css`
  display: flex;
  gap: 1rem;
  justify-content: center;
  padding: 2rem 0;

  @media screen and (width > ${theme.sizes.screens.md}) {
    justify-content: space-between;
    flex-direction: column;
  }
`;

export const ratings = css`
  margin: 0 calc(var(--screen-padding) * -1);
  width: calc(100% + (var(--screen-padding) * 2));
  max-width: 100vw;
  min-width: 0%;
  & > * {
    min-height: 100%;
  }
`;

export const scrollContent = css`
  display: flex;
  gap: 1rem;
  padding: 2rem 1rem;
`;
